import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TmpIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99579)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 13H24V24H0V13H3V8H8V13ZM7.116 15.744V14.491H1V15.744H3.27V22H4.816V15.744H7.116ZM10.02 14.491H7.998V22H9.545V19.947L9.391 16.41L11.412 22H12.474L14.501 16.405L14.346 19.947V22H15.9V14.491H13.868L11.949 19.937L10.02 14.491ZM18.797 19.354H20.153C21.043 19.354 21.741 19.142 22.244 18.718C22.748 18.293 23 17.713 23 16.977C23 16.492 22.885 16.06 22.654 15.68C22.4192 15.2956 22.0757 14.9894 21.667 14.8C21.239 14.594 20.743 14.491 20.179 14.491H17.249V22H18.797V19.354ZM18.797 18.101V15.744H20.215C20.597 15.751 20.895 15.868 21.113 16.095C21.329 16.322 21.437 16.619 21.437 16.987C21.437 17.345 21.33 17.62 21.115 17.812C20.9 18.005 20.588 18.102 20.179 18.102L18.797 18.101ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99579'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

TmpIcon.displayName = 'TmpIcon'
